import { useSetRecoilState } from "recoil";

import { useQuery, useQueryClient } from "react-query";
import { listBanks, getRecentAccount } from "../../api/bankApi";
import { useNavigate } from "react-router-dom";
import { useMutation } from "react-query";
import { cancelTicket } from "../../api/ticketApi";
import { authAtom } from "../../recoil/atoms";

// 넥스트에너지에서 허용하는 환불계좌 리스트 조회 훅
export const useBanks = () => {
  const setAuthAtom = useSetRecoilState(authAtom);
  const onError = ({ response: { status } }) => {
    if (status === 401) {
      // 인증에 실패한 경우는 로그아웃시키고 재로그인하도록 해야한다.
      setAuthAtom({ isLoggedIn: false, username: null, name: null });
    }
  };

  return useQuery("banks", listBanks, {
    select: (data) => data.data,
    onError,
  });
};

// 티켓 취소 훅
export const useCancelTicket = () => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const setAuthAtom = useSetRecoilState(authAtom);

  const onError = ({ response: { status } }) => {
    if (status === 401) {
      // 인증에 실패한 경우는 로그아웃시키고 재로그인하도록 해야한다.
      setAuthAtom({ isLoggedIn: false, username: null, name: null });
    }
  };
  const onSuccess = () => {
    queryClient.invalidateQueries("myTickets");
    navigate("/my-tickets", { replace: true });
  };
  return useMutation(cancelTicket, {
    onError,
    onSuccess,
  });
};

// 해당 티켓의 주문에 저장된 최근 환불계좌 정보 조회 훅
export const useGetRecentAccount = (purchasePk) => {
  const setAuthAtom = useSetRecoilState(authAtom);
  const onError = ({ response: { status } }) => {
    if (status === 401) {
      // 인증에 실패한 경우는 로그아웃시키고 재로그인하도록 해야한다.
      setAuthAtom({ isLoggedIn: false, username: null, name: null });
    }
  };

  return useQuery("recentAccount", () => getRecentAccount(purchasePk), {
    select: (data) => data.data,
    onError,
  });
};

export const toFirstElement = (banks, bank) => {
  const foundIdx = banks.findIndex((el) => el.name === bank);
  const foundItem = banks.find((el) => el.name === bank);
  if (foundIdx === -1) return;
  banks.splice(foundIdx, 1);
  banks.unshift(foundItem);
};

export const findBank = (banks, bank) => {
  const foundIdx = banks.findIndex((el) => el.name === bank);
  if (foundIdx === -1) return null;
  const foundItem = banks.find((el) => el.name === bank);
  return foundItem;
};
